import { useEffect, useState } from 'react';
import axios from 'axios';

const apiUrl = "https://elcobradorleague.com/api";

export const useArmyboard = (idleague) => {
  const [factions, setFactions] = useState([]);
    useEffect(() => {
    if (!idleague) return;

    axios.get(`${apiUrl}/api.php?endpoint=armyboard`)
      .then(res => {
        const data = res.data;
        if (data && typeof data === 'object') {
          const formatted = Object.entries(data).map(([key, armies]) => {
            const filteredArmies = armies.filter(a => a.idleague === idleague);
            const factionName = filteredArmies[0]?.factionName ?? key;
            return {
              faction: factionName,
              armies: filteredArmies
            };
          }).filter(div => div.armies.length > 0);
          setFactions(formatted);
        } else {
          setFactions([]);
        }
      })
      .catch(() => setFactions([]));
  }, [idleague]);
  return { factions };
};
